export const productFaqs = [
  {
    question: "Can a pad really affect cramps and mood?",
    answer:
      "Yes. Pads that trap heat and moisture can increase skin irritation and local inflammation, which may worsen cramp discomfort. Eveya’s breathable, skin-safe design combined with graphene technology helps regulate temperature and dissipate heat, creating a cooler, drier environment at the skin surface. Graphene is known for its high thermal conductivity and anti-inflammatory, antibacterial properties, which support better micro-circulation and reduced irritation. Many users therefore experience improved comfort and feel less irritable during their period."
  },
  {
    question: "I have super sensitive skin. Will these work for me?",
    answer:
      "Pads made with soft, breathable, and chemical-safe materials are generally better tolerated by sensitive skin. While everybody is different, many people with sensitive skin experience less irritation with these types of pads."
  },
  {
    question: "Why do I still leak even when I use the 'right' size pad?",
    answer:
      "Movement changes how fluid flows, causing it to spread sideways or backward. Pads with effective leak barriers and good fit help guide fluid into the absorbent core and reduce leakage."
  },
  {
    question: "Can a pad really stay secure all night?",
    answer:
      "Yes—when it’s designed for movement. Eveya’s extra-wide, multi-position wings and extended back coverage keep the pad anchored and protected from side and back leaks, so you can sleep through the night with confidence."
  },
  {
    question: "Why does breathability matter? It's just a pad?",
    answer:
      "Breathable pads allow air circulation, which reduces heat and moisture around the skin. This helps lower the risk of irritation, odor, and discomfort."
  },
  {
    question: "Do breathable pads leak more?",
    answer:
      "No. Breathability does not mean liquid can pass through. Breathable pads use micro-porous layers that allow air to circulate while still blocking liquid, so you get airflow for comfort without compromising leak protection."
  },
  {
    question: "Are thin pads really as absorbent as thick ones?",
    answer:
      "Yes. Thin pads can be just as absorbent as thick ones because modern super-absorbent polymers (SAPs) hold many times their weight in liquid while staying slim. That means you get strong absorption without bulk."
  },
  {
    question: "How long can I safely wear one pad?",
    answer:
      "Most women can safely wear a pad for up to 6–8 hours, depending on flow. Pads with high-absorbency cores that lock fluid inside stay drier for longer and reduce odor compared to basic pads that only soak liquid into surface layers. For hygiene and skin health, it’s best to change your pad at least every 8 hours, even if it doesn’t feel full."
  },
  {
    question: "What's the big deal about dioxins? Should I be worried?",
    answer:
      "Dioxins are toxic byproducts from chlorine bleaching used in some pads. Long-term exposure can accumulate in the body, and vulvar skin absorbs chemicals easily. Choosing dioxin-free pads simply reduces unnecessary chemical exposure and is a safer everyday choice."
  },
  {
    question: "Why do regular pads bunch, shift, or twist?",
    answer:
      "Most regular pads use small wings and weak adhesive, so they lose grip when you move—leading to bunching and twisting. Eveya uses extra-wide wings, strong adhesive, and a flexible core that moves with your body. The result: your pad stays in place without constant adjusting, so you stay comfortable and confident."
  },
  {
    question: "Can I wear these for sports or workouts?",
    answer:
      "Yes. Eveya pads are designed for movement. Extra-wide wings and strong adhesive keep them secure, while the soft, thin, flexible design prevents chafing and bulk. You can run, stretch, jump, and train comfortably—without worrying about shifting or leaks."
  },
  {
    question: "What actually makes Eveya different from Brand X?",
    answer:
      "Eveya is designed for comfort, safety, and performance—not just absorption. • Soft, breathable layers (not plastic-feel) • Dioxin-free, fragrance-free, skin-safe materials • Multi-layer leak barriers with a strong absorbent core • Extra-wide wings and strong adhesive for no shifting • Thin, flexible design that moves with your body. Bottom line: Regular pads focus on catching blood. Eveya focuses on making periods easier, safer, and more comfortable."
  },
  {
    question: "Is Eveya worth the extra cost?",
    answer:
      "Yes—because it replaces multiple hidden costs. • One pad that actually works (no doubling up) • Fewer leaks mean fewer ruined underwear • No spending on rash or irritation treatments • More comfort and confidence. Bottom line: You may pay a little more per pad, but you spend less overall—and feel better using it."
  },
  {
    question: "Okay, but seriously—what's the ONE thing that makes Eveya special?",
    answer:
      "Eveya is designed around how women actually live—not just around absorbing blood. That means comfort for sensitive skin, stability during movement, and protection that adapts to real life (work, sleep, workouts, travel). Bottom line: Most pads just catch blood. Eveya supports your body and your life."
  }
];


export const dischargeFaqs = [
  {
    question: "Is it normal for discharge to stain my underwear?",
    answer:
      "Yes. Discharge can turn yellowish or brownish on fabric when exposed to air, which is normal and not a sign of infection. Many women use panty liners for comfort, especially mid-cycle."
  },
  {
    question: "My discharge smells metallic/fishy during my period. Is that normal?",
    answer:
      "A mild metallic smell during your period is normal due to iron in blood. A fishy odor is not normal and may indicate bacterial vaginosis—see a doctor."
  },
  {
    question: "Why is my discharge sometimes watery and sometimes thick?",
    answer:
      "Discharge changes with hormones. Watery or slippery discharge often appears near ovulation, while creamy or thicker discharge is common after ovulation. These shifts are normal and healthy."
  },
  {
    question: "Is douching safe?",
    answer:
      "No. Douching disrupts the vagina’s natural balance and increases the risk of infections. The vagina is self-cleaning—plain water for external washing is enough."
  },
  {
    question: "Does discharge mean I'm dirty?",
    answer:
      "No. Discharge is a sign of a healthy, functioning vagina and normal hormones. It doesn’t mean you’re dirty—basic hygiene is all that’s needed."
  },
  {
    question: "Can I get an infection from sex?",
    answer:
      "Yes. Some infections are spread through sexual contact. Using condoms, getting regular STI testing, and having open conversations with partners help reduce risk."
  },
  {
    question: "Is it OK to use scented pads?",
    answer:
      "It’s best to avoid them. Fragrances can irritate and disrupt the vagina’s natural balance. Unscented products are safer."
  },
  {
    question: "When should I see a gynaecologist about discharge?",
    answer:
      "See a doctor if discharge changes color, develops a strong foul smell, is accompanied by itching, burning, or pain, or if you’re concerned. Seek urgent care if discharge comes with fever or pelvic pain. An annual checkup is recommended for preventive care."
  },
  {
    question: "Is clear discharge before my period a sign of pregnancy?",
    answer:
      "Not necessarily. Clear or creamy discharge can happen in the normal cycle as well as early pregnancy. The only reliable way to know is a pregnancy test after a missed period."
  },
  {
    question: "My discharge has a slight brown tint. Is that period starting?",
    answer:
      "Possibly. Brown discharge often means a small amount of old blood and can appear just before your period or around ovulation. If it’s light and brief, it’s usually normal."
  }
];


export const pantyFaqs = [
  {
    question: "What type of underwear should I wear during my period?",
    answer:
      "Choose mostly cotton underwear. Cotton is breathable, absorbs moisture, and helps pads stay in place, reducing leaks and irritation. Synthetic fabrics can trap heat and moisture and make pads shift."
  },
  {
    question: "Does it matter if my underwear has spandex?",
    answer:
      "Yes. A small amount is fine, but too much stretch can make pads shift. Aim for mostly cotton underwear with up to 5% spandex. Avoid styles where polyester or spandex is the main fabric."
  },
  {
    question: "Does underwear fit affect how pads work?",
    answer:
      "Yes. Underwear that’s too tight or too loose can cause pads to shift and leak. A snug but comfortable fit helps pads stay in place. A simple test: you should be able to fit one finger under the waistband."
  },
  {
    question: "What about my underwear width/crotch area?",
    answer:
      "Yes. The crotch should be wide enough for your pad to sit flat. If underwear is too narrow, pads can bunch or shift. If you often have placement issues, trying a wider-crotch style can help."
  },
  {
    question: "Should I wear different underwear during heavy vs light days?",
    answer:
      "Not necessary. The same cotton underwear works for all days—just adjust pad size to match your flow. If you prefer, using a fresh pair on heavy days can feel more comfortable."
  },
  {
    question: "Why do I get chafing with pads?",
    answer:
      "Chafing is usually caused by friction, tight underwear, or wearing pads too long. Switching to cotton underwear, choosing a comfortable fit, and changing pads every 4–6 hours can help prevent it."
  },
  {
    question: "What underwear style works best for pads (bikini vs brief)?",
    answer:
      "Most styles work if they’re comfortable and mostly cotton. Bikini, brief, and boy-short styles all support pads well. Avoid thongs during your period since pads can’t sit properly."
  }
];


export const cycleFaqs = [
  {
    question: "Is my cycle always 28 days?",
    answer:
      "No. A healthy cycle can range from 21–35 days. Many women naturally have shorter or longer cycles. Ovulation usually happens 12–16 days before your next period, so total length varies. If your cycle suddenly changes a lot or regularly falls outside this range, consult a doctor."
  },
  {
    question: "Why do I crave chocolate before my period?",
    answer:
      "Before your period, your body needs more energy, magnesium drops, and serotonin dips—so chocolate and carbs feel extra appealing. What helps: Eat a bit more, include magnesium-rich foods, and enjoy carbs without guilt."
  },
  {
    question: "Can I predict my period?",
    answer:
      "Yes—approximately. Count your average cycle length from Day 1 of your last period to estimate your next one. Period-tracking apps can help, and tracking ovulation signs (like cervical mucus or basal temperature) improves accuracy."
  },
  {
    question: "What if I'm on birth control—do I still have a cycle?",
    answer:
      "It depends. Hormonal birth control suppresses ovulation and creates a hormone-controlled pattern, not a natural cycle (the bleed is withdrawal bleeding). A copper IUD is non-hormonal, so you still ovulate and have a natural cycle."
  },
  {
    question: "Can stress delay my period?",
    answer:
      "Yes. High stress can delay ovulation, which delays your period by days or even weeks. Extreme exercise, sudden weight changes, poor sleep, or illness can do the same. If this happens often, focusing on stress management and rest can help."
  },
  {
    question: "Why is my flow heavier some months?",
    answer:
      "Some variation is normal. Heavier flow can be linked to stress, nutrition gaps, intense exercise, or conditions like fibroids or endometriosis. See a doctor if you soak pads every 1–2 hours, bleed over 7 days, or your flow disrupts daily life."
  },
  {
    question: "Is it normal to bleed during ovulation?",
    answer:
      "Light spotting around ovulation can be normal and is often due to a brief estrogen drop. Heavy bleeding at this time is not normal—see a doctor."
  },
  {
    question: "How does my cycle affect my workouts?",
    answer:
      "Strength and endurance are usually highest in the follicular phase and around ovulation, then gradually dip in late luteal. Try scheduling your hardest workouts earlier in the cycle and using the late luteal phase for moderate intensity and recovery."
  },
  {
    question: "Does my cycle affect my mental health?",
    answer:
      "Yes. Brain chemicals that affect mood shift across the cycle, and symptoms often worsen in the late luteal phase. If mood changes feel severe or disruptive, talk to a mental health professional—effective treatments are available."
  },
  {
    question: "Should I avoid sex during certain phases?",
    answer:
      "You don’t need to avoid sex for health reasons. If pregnancy prevention is your goal, the most fertile window is the few days before and during ovulation. Using barrier methods and tracking ovulation can help reduce risk."
  },
  {
    question: "Does my cycle affect my skin?",
    answer:
      "Yes. Skin is often clearest in the follicular phase and more prone to oiliness and breakouts in the late luteal phase. Keep your regular routine earlier in the cycle and add gentle extra cleansing later—without over-stripping."
  },
  {
    question: "Can my cycle affect my digestion?",
    answer:
      "Yes. Digestion is often smoother earlier in the cycle and slower in the luteal phase, which can cause bloating, constipation, or loose stools. Staying hydrated, eating enough fiber, and choosing anti-inflammatory foods can help."
  },
  {
    question: "Does my cycle affect my immune system?",
    answer:
      "Yes. Immunity tends to be stronger earlier in the cycle and slightly lower in the luteal phase. If possible, schedule vaccinations or routine procedures in the follicular phase."
  },
  {
    question: "How does aging affect my cycle?",
    answer:
      "Cycles are often irregular after puberty and again during perimenopause, most regular in the 20s–40s, and stop at menopause. Stress and health factors can affect cycles at any age."
  },
  {
    question: "What if my cycle is irregular?",
    answer:
      "Some variation is normal, but stress, PCOS, thyroid issues, low body weight, overtraining, or perimenopause can affect regularity. See a doctor if your cycle suddenly changes, stops, or consistently falls outside 21–35 days."
  }
];


export const bodyTypeFaqs = [
  {
    question: "Why do pads leak if I'm using the right size?",
    answer:
      "Leaks often happen because of pad shape mismatch, slippery synthetic underwear, or using the same pad size on heavy and light days. Switching to cotton underwear and matching pad size to your flow usually solves the problem."
  },
  {
    question: "How do I know what pad size I actually need?",
    answer:
      "Match pad size to your flow and body, not just the label. Heavier days usually need larger pads, lighter days smaller ones. Hip width also matters—wider hips often need wider pads. Testing different sizes across your period helps you find what fits best."
  },
  {
    question: "Does my body type really affect which pad size I need?",
    answer:
      "Yes. Hip width matters most, and height also plays a role. Wider hips and taller frames often need wider or longer pads, while narrower hips may be more comfortable with smaller sizes. If a pad leaks, it may be a fit issue—not a quality issue—so testing different sizes helps find what works for your body."
  },
  {
    question: "What's the difference between Regular, Large, XL, and XXL pads?",
    answer:
      "They mainly differ in length and absorbency. Regular suits light flow, Large for medium flow, XL for heavy flow, and XXL for very heavy or overnight use. Using larger sizes on heavier days and smaller ones on lighter days helps prevent leaks and discomfort."
  },
  {
    question: "Heavy flow is normal, but when is it actually too heavy?",
    answer:
      "Heavy flow can be normal, especially in the first few days. Consider seeing a doctor if you're soaking pads every 30–60 minutes for several hours, bleeding longer than 7 days, or feeling very fatigued or dizzy."
  },
  {
    question: "My pad keeps shifting no matter what size I use. What am I missing?",
    answer:
      "It's usually not the pad—it's underwear or placement. Slippery synthetic underwear, overly tight or loose fits, or off-center placement can cause shifting. Switching to mostly cotton underwear and centering the pad properly solves this for most women."
  },
  {
    question: "Why do I get uncomfortable when wearing pads?",
    answer:
      "Discomfort is usually caused by friction, moisture, heat, or poor fit. Wearing mostly cotton underwear, choosing the right pad size, and changing pads every 4–6 hours can greatly improve comfort."
  },
  {
    question: "Is a heavier body weight affecting my pad leakage?",
    answer:
      "It can be associated with heavier flow, which is normal. This simply means you may need larger pad sizes or more frequent changes. If heavy bleeding is accompanied by severe pain, dizziness, or fatigue, consider seeing a doctor."
  },
  {
    question: "How often should I change my pad?",
    answer:
      "Most people should change pads every 4–6 hours, and more often on heavy days. Avoid wearing a pad longer than 8 hours (except overnight pads). Changing when saturated helps prevent irritation and infections."
  },
  {
    question: "What's the difference between day pads and overnight pads?",
    answer:
      "Day pads are shorter and designed for upright movement, while overnight pads are longer, more absorbent, and provide extra back coverage for lying down. Using the right pad for day and night improves comfort and leak protection."
  },
  {
    question: "Do I need different pads for different days of my period?",
    answer:
      "Yes. Use larger pads on heavy days and smaller pads on lighter days. Matching pad size to daily flow reduces leaks and improves comfort."
  },
  {
    question: "What's happening if my pad bunches or feels uncomfortable?",
    answer:
      "Bunching usually means the pad is too long, the underwear is too tight or stretchy, or the pad isn't centered properly. Trying a slightly shorter pad, wearing mostly cotton underwear, and adjusting placement often fixes the issue."
  },
  {
    question: "Why should I pair my pad with the right underwear?",
    answer:
      "Because underwear helps hold the pad in place and manage moisture. Mostly cotton, well-fitting underwear improves grip, comfort, and leak protection. The same pad can perform very differently depending on the underwear you wear."
  }
];
